import { Alert } from "@idg-web-platform/pulse";
import css from "./approvalBox.module.css";

/**
 * Shown while a membership waits for approval (ApprovalRequired or ApprovalRequested) but the existing
 * CLUB membership already belongs to another online account. No approval email is sent and an earlier
 * link is refused: linking it would share one CLUB membership between two accounts, so only customer
 * service can help.
 */
export function AlreadyLinkedBox() {
  return (
    <Alert
      type="warning"
      headline="Deine CLUB-Mitgliedschaft gehört zu einem anderen Kundenkonto"
      showCloseButton={false}
      description="Deine INTERSPORT CLUB Mitgliedschaft ist bereits mit einem anderen Kundenkonto verknüpft. Leider kann man immer nur eine CLUB Mitgliedschaft mit einem Kundenkonto verbinden."
    >
      <div className={css.alertContent}>
        Wenn du deine CLUB Mitgliedschaft mit deinem neuen Kundenkonto verwenden möchtest, melde
        dich bitte bei unserem <a href="/c/account/contact?issue=club">Kundenservice</a>.
      </div>
    </Alert>
  );
}
